import * as React from "react";


// components/footer/variants/FooterHills.tsx
export const FooterHills = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 1440 73"
    width="100%"                       // ✅ SVG accepts this
    style={{ height: "auto", ...props.style }} // ✅ CSS handles height
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}                         // className, etc.
  >
    <path
      opacity={0.3}
      d="M0 9.09715C240 -5.31691 380 -0.512224 560 9.09715C740 18.7065 980 23.5112 1440 9.09715V72.519H0V9.09715Z"
      fill="url(#paint0_linear_207_664)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_207_664"
        x1={0}
        y1={0}
        x2={0}
        y2={7251.9}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D5EAD0" stopOpacity={0.9} />
        <stop offset={1} stopColor="#CDE4C8" stopOpacity={0.9} />
      </linearGradient>
    </defs>

    <path
      opacity={0.5}
      d="M0 4.11164C200 -5.49774 420 4.11164 650 8.91632C880 13.721 1120 13.721 1440 6.51398V53.1194H0V4.11164Z"
      fill="url(#paint0_linear_207_666)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_207_666"
        x1={0}
        y1={0}
        x2={0}
        y2={5311.94}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CBE3C6" stopOpacity={0.8} />
        <stop offset={1} stopColor="#BFDDBB" stopOpacity={0.8} />
      </linearGradient>
    </defs>

    <path
      opacity={0.7}
      d="M0 4.61706C260 -12.1028 520 21.3369 760 29.6968C1000 38.0568 1240 29.6968 1440 21.3369V125H0V4.61706Z"
      fill="url(#paint0_linear_207_668)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_207_668"
        x1={0}
        y1={0}
        x2={0}
        y2={12500}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B8D7B3" stopOpacity={0.75} />
        <stop offset={1} stopColor="#A9CFAB" stopOpacity={0.75} />
      </linearGradient>
    </defs>
  </svg>
);

// components/footer/variants/FooterWaves.tsx
export const FooterWaves = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 1440 120"
    width="100%"
    style={{ height: "auto", ...props.style }}
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity={0.3}
      d="M0 40C240 10 480 20 720 40C960 60 1200 50 1440 30V120H0V40Z"
      fill="url(#wave_grad_1)"
    />
    <defs>
      <linearGradient
        id="wave_grad_1"
        x1={0}
        y1={0}
        x2={0}
        y2={120}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D5EAD0" stopOpacity={0.9} />
        <stop offset={1} stopColor="#CDE4C8" stopOpacity={0.9} />
      </linearGradient>
    </defs>

    <path
      opacity={0.5}
      d="M0 60C260 20 520 50 780 70C1040 90 1240 80 1440 60V120H0V60Z"
      fill="url(#wave_grad_2)"
    />
    <defs>
      <linearGradient
        id="wave_grad_2"
        x1={0}
        y1={0}
        x2={0}
        y2={120}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CBE3C6" stopOpacity={0.8} />
        <stop offset={1} stopColor="#BFDDBB" stopOpacity={0.8} />
      </linearGradient>
    </defs>

    <path
      opacity={0.7}
      d="M0 80C300 40 600 90 900 100C1200 110 1320 95 1440 85V120H0V80Z"
      fill="url(#wave_grad_3)"
    />
    <defs>
      <linearGradient
        id="wave_grad_3"
        x1={0}
        y1={0}
        x2={0}
        y2={120}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B8D7B3" stopOpacity={0.75} />
        <stop offset={1} stopColor="#A9CFAB" stopOpacity={0.75} />
      </linearGradient>
    </defs>
  </svg>
);


// components/footer/variants/FooterMountains.tsx
export const FooterMountains = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 1440 160"
    width="100%"
    style={{ height: "auto", ...props.style }}
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity={0.3}
      d="M0 120L240 70L480 110L720 50L960 100L1200 60L1440 120V160H0V120Z"
      fill="url(#mountain_grad_1)"
    />
    <defs>
      <linearGradient
        id="mountain_grad_1"
        x1={0}
        y1={0}
        x2={0}
        y2={160}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D5EAD0" stopOpacity={0.9} />
        <stop offset={1} stopColor="#CDE4C8" stopOpacity={0.9} />
      </linearGradient>
    </defs>

    <path
      opacity={0.5}
      d="M0 140L300 90L600 130L900 80L1200 110L1440 140V160H0V140Z"
      fill="url(#mountain_grad_2)"
    />
    <defs>
      <linearGradient
        id="mountain_grad_2"
        x1={0}
        y1={0}
        x2={0}
        y2={160}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CBE3C6" stopOpacity={0.8} />
        <stop offset={1} stopColor="#BFDDBB" stopOpacity={0.8} />
      </linearGradient>
    </defs>

    <path
      opacity={0.7}
      d="M0 150L360 110L720 140L1080 100L1440 150V160H0V150Z"
      fill="url(#mountain_grad_3)"
    />
    <defs>
      <linearGradient
        id="mountain_grad_3"
        x1={0}
        y1={0}
        x2={0}
        y2={160}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B8D7B3" stopOpacity={0.75} />
        <stop offset={1} stopColor="#A9CFAB" stopOpacity={0.75} />
      </linearGradient>
    </defs>
  </svg>
);

